import {useEffect} from 'react'

export function useAsyncEffect(effect, destroy, inputs) {
	const hasDestroy = typeof destroy === 'function'

	useEffect(
		function () {
			let result
			let mounted = true
			const maybePromise = effect(function () {
				return mounted
			})

			Promise.resolve(maybePromise).then(function (value) {
				result = value
			})

			return function () {
				mounted = false

				if (hasDestroy) {
					destroy(result)
				}
			}
		},
		hasDestroy ? inputs : destroy,
	)
}
